import { render, staticRenderFns } from "./CMS.vue?vue&type=template&id=2e54a234&scoped=true&"
import script from "./CMS.vue?vue&type=script&lang=js&"
export * from "./CMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54a234",
  null
  
)

export default component.exports